import { IPageMeta } from '../../types/page';
import { IApplicationState } from '../../types/redux';

export function selectPageMeta(state: IApplicationState): IPageMeta {
  return {
    title: state.seoData.title,
    metaDescription: state.seoData.metaDescription,
  };
}
